module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"table":{"copied":"Copiado: {0}"}},"en-US":{"table":{"copied":"Copied: {0}"}}}')
  delete Component.options._Ctor
}
